import { BgcQuestionnaireRequest } from '../../../../../shared/models/services-request/bgc-questionnaire.model';
import { customValidator } from '../../../../../Utils/validator';
import { Component, DestroyRef, OnInit } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ValidationMessageComponent } from '../../../../../shared/components/validation-message/validation-message.component';
import { SHARED_COMPONENTS } from '../../../../../shared/shared-imports';
import { formatDate, NgClass } from '@angular/common';

@Component({
  selector: 'app-bgc-questionaries',
  imports: [ReactiveFormsModule, NgClass, TranslateModule, ValidationMessageComponent, ...SHARED_COMPONENTS],
  templateUrl: './bgc-questionaries.component.html'
})
export class BgcQuestionariesComponent implements OnInit {
  readonly translationPrefix = 'BUSINESS_GROUP.QUESTIONARIES.';
  // Temporary display name until the group details API is provided.
  groupName = 'Agri Trading Business Group';
  groupId: string = '';
  email: string = '';
  srNumber: string = '';
  expiryDate: string | Date = '';
  readonly form;
  pendingSubmission: BgcQuestionnaireRequest | null = null;
  isGuestView = true;

  get member_info() {
    let deadline = '';
    this.expiryDate = new Date();
    if (this.expiryDate) {
       deadline = formatDate(this.expiryDate, 'EEEE, dd MMMM yyyy', 'en-US');
    }
    return {
      ...QuestionaryInfo,
      sections: QuestionaryInfo.sections.map((section: any, index: number) => index === 1
        ? {
          ...section, title: this.translate.instant('BUSINESS_GROUP.QUESTIONARIES.REGISTRATION_DEADLINE') +
            (deadline ? deadline : '')
        }
        : section)
    };
  }
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private destroyRef: DestroyRef,
    private translate: TranslateService
  ) {
    this.form = this.fb.group({
      nomineeFullName: ['', Validators.required],
      emailAddress: ['', [Validators.required, customValidator('email')]],
      mobileNumber: ['', [Validators.required, customValidator('mobile')]],
      companyName: ['', Validators.required],
      tradeLicenseNumber: ['', Validators.required],
      currentPosition: ['', Validators.required],
      boardPositions: new FormControl<string[]>([], { nonNullable: true, validators: Validators.required })
    });
  }

  ngOnInit(): void {
    this.readInvitationParameters();
  }

  private readInvitationParameters(): void {
    this.route.queryParamMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      this.groupId = params.get('groupid') || '';
      this.email = params.get('email') || '';
      this.srNumber = params.get('srnumber') || '';
      this.expiryDate = params.get('expirydate') || '';
      this.form.controls.emailAddress.setValue(this.email);
    });
  }

  submitQuestionnaire(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid) return;
    // Link validation and API submission will be added when the workflow is supplied.
    const data = this.form.getRawValue();
    const request = new BgcQuestionnaireRequest();
    request['Group Id'] = this.groupId;
    request['Email'] = this.email;
    request['SR Number'] = this.srNumber;
    request['Expiry Date'] = this.expiryDate instanceof Date ? this.expiryDate.toISOString() : this.expiryDate;
    request['DC Requestor Name'] = data.nomineeFullName ?? '';
    request['DC Requestor Email'] = data.emailAddress ?? '';
    request['DC Requestor Phone Number'] = data.mobileNumber ?? '';
    request['DC Company Name'] = data.companyName ?? '';
    request['DC Trade License Number'] = data.tradeLicenseNumber ?? '';
    request['DC Position'] = data.currentPosition ?? '';
    request['Board Positions'] = [...data.boardPositions];
    this.pendingSubmission = request;
    console.log(this.pendingSubmission);
  }

}
export const QuestionaryInfo: any = {
  title: 'BUSINESS_GROUP.QUESTIONARIES.ELIGIBILITY_TITLE',
  message: '',
  sections: [
    {
      title: '',
      items: ['BUSINESS_GROUP.QUESTIONARIES.ELIGIBILITY_1', 'BUSINESS_GROUP.QUESTIONARIES.ELIGIBILITY_2'],
    },
    {
      title: 'BUSINESS_GROUP.QUESTIONARIES.REGISTRATION_DEADLINE',
      items: [
        'BUSINESS_GROUP.QUESTIONARIES.SUBMISSION_NOTICE',
      ],
    }
  ]
};
